import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { NavLink } from "react-router-dom";
import { getIcon } from "@dishopsaas/design-system";
import { Styles } from "./SideTabBar.styles";
import { useInfoBar } from "../../hooks/useInfoBar";
import {
  ACCOUNT_ORDERS_ROUTE,
  ACCOUNT_PROFILE_ROUTE
} from "../../constants/routes";
import { getColors, isDarkTheme } from "../../utils";
import { COLOR_NEUTRAL_100 } from '../../constants/configuration'

type TabLinkProps = {
  to: string;
  label: string;
  icon: string;
  primaryColor: string;
};

const TabLink: React.FC<TabLinkProps> = ({ to, label, icon }) => (
  <NavLink
    to={to}
    style={({ isActive }) => {
      const { surfaceSecondary, text } = getColors();
      return {
        ...Styles.tabStyle,
        ...(isActive && { background: isDarkTheme() ? surfaceSecondary : COLOR_NEUTRAL_100, borderRadius: "999px" }),
        color: text,
      };
    }}
  >
    <>
      {getIcon(icon)}
      <Box>
        <Typography variant="body1">{label}</Typography>
      </Box>
    </>
  </NavLink>
);

export const SideTabBar = () => {
  const theme = useTheme();
  const PRIMARY_COLOR = theme.palette.primary.main;
  const infoBar = useInfoBar();

  return (
    <Box
      sx={{
        ...(infoBar.isMobile ? Styles.mobileContainer : Styles.container),
      }}
    >
      <TabLink
        to={ACCOUNT_ORDERS_ROUTE}
        label="Mes commandes"
        icon="HandPlatter"
        primaryColor={PRIMARY_COLOR}
      />
      <TabLink
        to={ACCOUNT_PROFILE_ROUTE}
        label="Mon compte"
        icon="person"
        primaryColor={PRIMARY_COLOR}
      />
    </Box>
  );
};
